import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';

import { StorageService } from 'src/app/services/storage.service';
import { OnboardingDialogComponent } from '../../onboarding-dialog/onboarding-dialog.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() openSideNav = new EventEmitter<any>();
  @Output() isHandsetPortraitStatus = new EventEmitter<any>();
  @Output() onboardingIcon = new EventEmitter<any>();
  isHandsetPortrait: boolean = false;
  paImg: boolean = false;
  enImg: boolean = false;
  activeItem: any ='';
  constructor(
    private responsive: BreakpointObserver,
    private storage: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }),
    this.activeItem = this.router.url.split('/').pop();
    let appLanguage = this.storage.get('language');
    if(appLanguage == 'en'){
      this.enImg = true;
    }else{
      this.paImg = true;
    } 

    this.storage.set('language', appLanguage ? appLanguage : 'en');
    this.responsive
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((result) => {
        const breakpoints = result.breakpoints;

        this.isHandsetPortrait = breakpoints[Breakpoints.HandsetPortrait]
          ? true
          : false;
        this.isHandsetPortraitStatus.emit(this.isHandsetPortrait);
      });
  }

  tabChange(tabChangedEvent: MatTabChangeEvent) {
    if (tabChangedEvent.tab.textLabel === 'Guru Granth Sahib') {
      this.router.navigate(['/']);
    }
  }

  startTour(){
    if(this.router.url === '/' || this.router.url === '/home'){
    this.onboardingIcon.emit(true);
    }
    else{
      let dialogRef = this.dialog.open(OnboardingDialogComponent, {
        height: '178px',
        width: '635px',
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if(result){
          sessionStorage.setItem('url',this.router.url);
          this.router.navigate(["/"]);
        }
      });
      
      // dialogRef.close('Pizza!');
    }
  }

  onSelectLanguage(language: string) {
    this.storage.set('language', language);
    this.translate.use(language);

    // let thisUrl = this.router.url;
    let thisUrl = this.router.url.split('?')[0];
    console.log("this url from header component : ", thisUrl);
    
    // ✅ Existing query params store karo
    const urlParams = new URLSearchParams(this.router.url.includes('?') ? this.router.url.split('?')[1] : '');

    //-------------------- logic for the Home URL and language toggle --------------------
    if (thisUrl === '/home' && language === 'en') thisUrl = '/';
    if (thisUrl === '/' && language === 'pa') thisUrl = '/home';

    //------------ Agar URL mein pehle se 'english' ya 'panjabi' hai toh usko update karo -----------
    if (thisUrl.includes('english') || thisUrl.includes('panjabi')) {
        let baniLanguageString = language === 'en' ? 'english' : 'panjabi';
        thisUrl = thisUrl.includes('english')
            ? thisUrl.replace(/english/g, baniLanguageString)
            : thisUrl.replace(/panjabi/g, baniLanguageString);
    }

    // ✅ Agar language 'pa' hai AND URL '/' ya '/home' nahi hai AND (pehle se lang param tha YA ab 'pa' select hua)
    const isHomeUrl = thisUrl === '/' || thisUrl === '/home';
    // const hasLangInUrl = this.router.url.includes('/english/') || this.router.url.includes('/panjabi/');
    const hasLangInUrl = /\/(english|panjabi)(\/|$)/.test(this.router.url);
    const isBaniOrDetailUrl = this.router.url.includes('/bani/') || this.router.url.includes('/bani/details/');

    // ✅ lang param update/add/remove karo
    if (language === 'pa' && (!isHomeUrl && (!hasLangInUrl || isBaniOrDetailUrl))) {
        urlParams.set('lang', 'pa');
    } else {
        urlParams.delete('lang');
    }

    // ✅ Agar koi bhi param bacha hai toh URL mein lagao
    const queryString = urlParams.toString();
    if (queryString) {
        thisUrl = thisUrl + '?' + queryString;
    }

    const urlIsInBaniSearchText = this.isUrlMatchingFormatwithBaniDetailsTxt(thisUrl);

    // ✅ Final solution
    const tempUrl = (thisUrl === '/' || thisUrl === '/home') ? 
        (thisUrl === '/' ? '/home' : '/') : '/';

    this.router.navigate([tempUrl], { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl(thisUrl, {
            // skipLocationChange: urlIsInBaniSearchText
            skipLocationChange: false
        });
    });
  }

  isUrlMatchingFormatwithBaniDetailsTxt(url: string): boolean {
    let decodedUrl = url;
    while (decodedUrl !== decodeURIComponent(decodedUrl)) {
      decodedUrl = decodeURIComponent(decodedUrl);
    }
    const regex = /\/bani\/details\/[A-Za-z0-9]+\/[0-9]+\/[0-9]+\?txt=[A-Za-z0-9]+/;
    const encodedRegex = /\/bani\/details\/[A-Za-z0-9]+\/[0-9]+\/[0-9]+%3Ftxt%3D[A-Za-z0-9]+/;
  
    return regex.test(decodedUrl) || encodedRegex.test(decodedUrl);
  }

  isTabActive(component: string) {
    const currentComponentName = this.route?.snapshot?.component?.name;

    let isTabActive = true;
    if (
      currentComponentName === 'GuruGranthSahibComponent' &&
      component === 'DashboardComponent'
    ) {
      isTabActive = true;
    }
  }

  goToPage(pageName: string) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    this.router.navigate([`info/${baniLanguageString}/${pageName}`]);
  }

  goToSimplePage(pageName: string) {
    this.router.navigate([`/${pageName}`]);
  }

  openPage(pageUrl: string) {
    window.open(pageUrl, '_blank');
  }

  goToSearchPage(): void {
    this.router.navigate(['/search']);
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }

  fetchLanguage(): string | null {
    return this.storage.get('language');
  }

  handleSideNav(): void {
    this.openSideNav.emit();
  }
  onDonateClick(): void {
    const donateUrl = 'https://sikhri.org/donate';
    window.open(donateUrl, '_blank');
  }
}
